import styled from 'styled-components'

export const StyledSearch = styled.div`
  width: 100%;
  display: block;
  margin: 0 auto;

  > label {
    display: block;
    margin-bottom:  ${({ theme }) => theme.rem(16)};
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;

  }

  ${({ theme }) => theme.mediaQuery.md(`
    --min: 480px;
    --ideal: ${theme.col(4)};
    --max:  ${theme.col(6)};

    max-width: clamp(var(--min), var(--ideal), var(--max));
  `)}
`
